import { publicApi } from "store/Api"

type AuthResponse = {
    access_token: string
    token_type: null
}

const deviceLogin = publicApi.injectEndpoints({

    endpoints: (build) => ({
        login: build.mutation<AuthResponse, FormData>({
            query: (data) => {
                return {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    url: `login`,
                    body: data,
                }
            },
        }),
    }),
})


export const { useLoginMutation } = deviceLogin

// Possible exports
export const { endpoints, reducerPath, reducer, middleware } = deviceLogin
